var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-1", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                _vm._l(_vm.delegation.country, function(country, index) {
                  return _c(
                    "v-card",
                    { key: index, staticStyle: { "margin-bottom": "15px" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "grey lighten-5 py-2" },
                        [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.form.countryFragment")
                              ) +
                                " " +
                                _vm._s(index + 1)
                            )
                          ]),
                          _c("v-spacer"),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.$store.getters[
                                                    "Ajax/loading"
                                                  ] ||
                                                  _vm.$store.state.Delegation
                                                    .readonly === true,
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeCountry(
                                                    country
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("close")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegation.form.removeThisCountryFragment"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { md: "4", sm: "6", cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "flex-nowrap",
                                      attrs: { dense: "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { staticClass: "py-0" },
                                        [
                                          _c("country-select", {
                                            attrs: {
                                              validationMessage:
                                                _vm.delegationErrors.country[
                                                  index
                                                ].country_code,
                                              model: country.country_code,
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true
                                            },
                                            on: {
                                              "update:model": function($event) {
                                                return _vm.$set(
                                                  country,
                                                  "country_code",
                                                  $event
                                                )
                                              },
                                              change: function($event) {
                                                country.region === ""
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.getRegions(country).length >
                                                1,
                                              expression:
                                                "getRegions(country).length > 1"
                                            }
                                          ],
                                          staticClass: "py-0"
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              "error-messages":
                                                _vm.delegationErrors.country[
                                                  index
                                                ].region,
                                              items: _vm.getRegions(country),
                                              label: _vm.$t(
                                                "delegation.form.fields.country.region.name"
                                              ),
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true
                                            },
                                            model: {
                                              value: country.region,
                                              callback: function($$v) {
                                                _vm.$set(country, "region", $$v)
                                              },
                                              expression: "country.region"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "2", sm: "6", cols: "12" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "flex-nowrap",
                                      staticStyle: { "margin-top": "0" },
                                      attrs: { "no-gutters": "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "error-messages":
                                            _vm.delegationErrors.country[index]
                                              .delegation_rate,
                                          label: _vm.$t(
                                            "delegation.form.fields.country.rate.name"
                                          ),
                                          suffix:
                                            country.country_code == null
                                              ? ""
                                              : country.currency,
                                          disabled: "",
                                          readonly:
                                            _vm.$store.state.Delegation
                                              .readonly === true
                                        },
                                        model: {
                                          value: country.delegation_rate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              country,
                                              "delegation_rate",
                                              $$v
                                            )
                                          },
                                          expression: "country.delegation_rate"
                                        }
                                      }),
                                      country.delegation_rate !== null &&
                                      _vm.$store.state.Delegation.readonly !==
                                        true
                                        ? _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              staticStyle: {
                                                                top: "10px"
                                                              },
                                                              attrs: {
                                                                icon: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  parseInt(
                                                                    country.delegation_rate
                                                                  ) === 0
                                                                    ? (country.delegation_rate = null)
                                                                    : (country.delegation_rate =
                                                                        "0.00")
                                                                }
                                                              }
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "fa-funnel-dollar"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              parseInt(
                                                country.delegation_rate
                                              ) > 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "delegation.form.doNotCalculatePerDiem"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              parseInt(
                                                country.delegation_rate
                                              ) === 0
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "delegation.form.restorePerDiemRate"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("date-time-picker-computed", {
                                    attrs: {
                                      "date-time-validation":
                                        _vm.delegationErrors.country[index]
                                          .in_date,
                                      dateTimeModel: country.in_date,
                                      "default-button": true,
                                      "default-value": _vm.startDateDefaultValueCountry(
                                        country
                                      ),
                                      label: _vm.$t(
                                        "delegation.form.fields.country.inDate.name"
                                      ),
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:dateTimeModel": function($event) {
                                        return _vm.$set(
                                          country,
                                          "in_date",
                                          $event
                                        )
                                      },
                                      "update:date-time-model": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          country,
                                          "in_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("date-time-picker-computed", {
                                    attrs: {
                                      "date-time-validation":
                                        _vm.delegationErrors.country[index]
                                          .out_date,
                                      dateTimeModel: country.out_date,
                                      "default-button": true,
                                      "default-value": _vm.endDateDefaultValueCountry(
                                        country
                                      ),
                                      label: _vm.$t(
                                        "delegation.form.fields.country.outDate.name"
                                      ),
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:dateTimeModel": function($event) {
                                        return _vm.$set(
                                          country,
                                          "out_date",
                                          $event
                                        )
                                      },
                                      "update:date-time-model": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          country,
                                          "out_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          model: {
                            value: _vm.expandedCountryArray[index],
                            callback: function($$v) {
                              _vm.$set(_vm.expandedCountryArray, index, $$v)
                            },
                            expression: "expandedCountryArray[index]"
                          }
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            {
                              on: {
                                change: function() {
                                  _vm.expandedAccommodation(
                                    country,
                                    _vm.expandedCountryArray[index]
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "grey lighten-5" },
                                [
                                  _c("span", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "delegation.form.accommodation"
                                          )
                                        ) + ": "
                                      )
                                    ]),
                                    _c("span", [
                                      _c("b", { staticClass: "green--text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.accommodationTotalDays(country)
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                ]
                              ),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _vm._l(country.accommodation, function(
                                    accommodation,
                                    indexAccommodation
                                  ) {
                                    return _c(
                                      "v-row",
                                      { key: indexAccommodation },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass:
                                              "flex-nowrap px-2 pr-12"
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "v-row",
                                                  { attrs: { dense: "" } },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        class: [
                                                          {
                                                            "xs12 sm6 md4":
                                                              accommodation.settlement_type_id !=
                                                              null
                                                          },
                                                          {
                                                            "xs12 sm12 md12":
                                                              accommodation.settlement_type_id ==
                                                              null
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        _c("v-select", {
                                                          attrs: {
                                                            "error-messages":
                                                              typeof _vm
                                                                .delegationErrors
                                                                .country[index]
                                                                .accommodation[
                                                                indexAccommodation
                                                              ] !== "undefined"
                                                                ? _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ]
                                                                    .settlement_type_id
                                                                : [],
                                                            items:
                                                              _vm.accommodationSettlementTypes,
                                                            label: _vm.$t(
                                                              "delegation.form.fields.accommodation.settlementType.name"
                                                            ),
                                                            "item-text": "text",
                                                            "item-value":
                                                              "value",
                                                            readonly:
                                                              _vm.$store.state
                                                                .Delegation
                                                                .readonly ===
                                                              true
                                                          },
                                                          model: {
                                                            value:
                                                              accommodation.settlement_type_id,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                accommodation,
                                                                "settlement_type_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "accommodation.settlement_type_id"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    accommodation.settlement_type_id ===
                                                    6
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              md: "8",
                                                              sm: "6",
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                "error-messages":
                                                                  typeof _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ] !==
                                                                  "undefined"
                                                                    ? _vm
                                                                        .delegationErrors
                                                                        .country[
                                                                        index
                                                                      ]
                                                                        .accommodation[
                                                                        indexAccommodation
                                                                      ].comment
                                                                    : [],
                                                                readonly:
                                                                  _vm.$store
                                                                    .state
                                                                    .Delegation
                                                                    .readonly ===
                                                                  true,
                                                                label: _vm.$t(
                                                                  "global.comment"
                                                                )
                                                              },
                                                              model: {
                                                                value:
                                                                  accommodation.comment,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    accommodation,
                                                                    "comment",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "accommodation.comment"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                      2 ||
                                                    accommodation.settlement_type_id ===
                                                      3 ||
                                                    accommodation.settlement_type_id ===
                                                      5
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              md: "2",
                                                              sm: "2",
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "currency-select",
                                                              {
                                                                attrs: {
                                                                  model:
                                                                    accommodation.currency,
                                                                  "validation-message":
                                                                    typeof _vm
                                                                      .delegationErrors
                                                                      .country[
                                                                      index
                                                                    ]
                                                                      .accommodation[
                                                                      indexAccommodation
                                                                    ] !==
                                                                    "undefined"
                                                                      ? _vm
                                                                          .delegationErrors
                                                                          .country[
                                                                          index
                                                                        ]
                                                                          .accommodation[
                                                                          indexAccommodation
                                                                        ]
                                                                          .currency
                                                                      : [],
                                                                  readonly:
                                                                    _vm.$store
                                                                      .state
                                                                      .Delegation
                                                                      .readonly ===
                                                                    true
                                                                },
                                                                on: {
                                                                  "update:model": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "currency",
                                                                      $event
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                      2 ||
                                                    accommodation.settlement_type_id ===
                                                      3 ||
                                                    accommodation.settlement_type_id ===
                                                      5
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              md: "1",
                                                              sm: "4",
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c("AmountInput", {
                                                              attrs: {
                                                                "error-messages":
                                                                  typeof _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ] !==
                                                                  "undefined"
                                                                    ? _vm
                                                                        .delegationErrors
                                                                        .country[
                                                                        index
                                                                      ]
                                                                        .accommodation[
                                                                        indexAccommodation
                                                                      ]
                                                                        .amount_in_currency
                                                                    : [],
                                                                model:
                                                                  accommodation.amount_in_currency,
                                                                "over-limit": _vm.overLimit(
                                                                  index,
                                                                  indexAccommodation
                                                                ),
                                                                readonly:
                                                                  _vm.$store
                                                                    .state
                                                                    .Delegation
                                                                    .readonly ===
                                                                  true
                                                              },
                                                              on: {
                                                                "update:model": function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$set(
                                                                    accommodation,
                                                                    "amount_in_currency",
                                                                    $event
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                      2 ||
                                                    accommodation.settlement_type_id ===
                                                      3 ||
                                                    accommodation.settlement_type_id ===
                                                      5
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              md: "2",
                                                              sm: "6",
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c("date-picker", {
                                                              attrs: {
                                                                "date-validation":
                                                                  typeof _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ] !==
                                                                  "undefined"
                                                                    ? _vm
                                                                        .delegationErrors
                                                                        .country[
                                                                        index
                                                                      ]
                                                                        .accommodation[
                                                                        indexAccommodation
                                                                      ]
                                                                        .invoice_date
                                                                    : [],
                                                                label: _vm.$t(
                                                                  "delegation.form.fields.accommodation.invoiceDate.name"
                                                                ),
                                                                model:
                                                                  accommodation.invoice_date,
                                                                readonly:
                                                                  _vm.$store
                                                                    .state
                                                                    .Delegation
                                                                    .readonly ===
                                                                  true
                                                              },
                                                              on: {
                                                                "update:model": function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$set(
                                                                    accommodation,
                                                                    "invoice_date",
                                                                    $event
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                      2 ||
                                                    accommodation.settlement_type_id ===
                                                      3 ||
                                                    accommodation.settlement_type_id ===
                                                      5
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              md: "3",
                                                              sm: "6",
                                                              cols: "12"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "ajax-single-file",
                                                              {
                                                                attrs: {
                                                                  accept:
                                                                    _vm.$store
                                                                      .getters[
                                                                      "Delegation/allowedAttachmentFileFormat"
                                                                    ],
                                                                  items: _vm.fileProperties(
                                                                    accommodation.file_id
                                                                  ),
                                                                  model:
                                                                    accommodation.file_id,
                                                                  "validation-message":
                                                                    typeof _vm
                                                                      .delegationErrors
                                                                      .country[
                                                                      index
                                                                    ]
                                                                      .accommodation[
                                                                      indexAccommodation
                                                                    ] !==
                                                                    "undefined"
                                                                      ? _vm
                                                                          .delegationErrors
                                                                          .country[
                                                                          index
                                                                        ]
                                                                          .accommodation[
                                                                          indexAccommodation
                                                                        ]
                                                                          .file_id
                                                                      : [],
                                                                  readonly:
                                                                    _vm.$store
                                                                      .state
                                                                      .Delegation
                                                                      .readonly ===
                                                                    true
                                                                },
                                                                on: {
                                                                  "update:model": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "file_id",
                                                                      $event
                                                                    )
                                                                  },
                                                                  fileRemoved:
                                                                    _vm.removeFileFromDelegationFiles,
                                                                  fileUploaded:
                                                                    _vm.addFileToDelegationFiles
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                    4
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "align-center d-flex"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "delegation.form.lumpSumWillBeCalculatedAutomatically"
                                                                  )
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    accommodation.settlement_type_id ===
                                                    1
                                                      ? _c(
                                                          "v-col",
                                                          [
                                                            _c(
                                                              "ajax-booking-hotel-select",
                                                              {
                                                                attrs: {
                                                                  bookingText:
                                                                    accommodation.booking_text,
                                                                  fileId:
                                                                    accommodation.file_id,
                                                                  model:
                                                                    accommodation.booking_id,
                                                                  "validation-message":
                                                                    typeof _vm
                                                                      .delegationErrors
                                                                      .country[
                                                                      index
                                                                    ]
                                                                      .accommodation[
                                                                      indexAccommodation
                                                                    ] !==
                                                                    "undefined"
                                                                      ? _vm
                                                                          .delegationErrors
                                                                          .country[
                                                                          index
                                                                        ]
                                                                          .accommodation[
                                                                          indexAccommodation
                                                                        ]
                                                                          .booking_id
                                                                      : [],
                                                                  readonly:
                                                                    _vm.$store
                                                                      .state
                                                                      .Delegation
                                                                      .readonly ===
                                                                    true
                                                                },
                                                                on: {
                                                                  "update:bookingText": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "booking_text",
                                                                      $event
                                                                    )
                                                                  },
                                                                  "update:booking-text": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "booking_text",
                                                                      $event
                                                                    )
                                                                  },
                                                                  "update:fileId": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "file_id",
                                                                      $event
                                                                    )
                                                                  },
                                                                  "update:file-id": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "file_id",
                                                                      $event
                                                                    )
                                                                  },
                                                                  "update:model": function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      accommodation,
                                                                      "booking_id",
                                                                      $event
                                                                    )
                                                                  },
                                                                  fileRemoved:
                                                                    _vm.removeFileFromDelegationFiles,
                                                                  fileUploaded:
                                                                    _vm.addFileToDelegationFiles,
                                                                  importAccommodationData: function(
                                                                    bookingData
                                                                  ) {
                                                                    return _vm.importAccommodationData(
                                                                      bookingData,
                                                                      accommodation
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-row",
                                                  { attrs: { dense: "" } },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          md: "2",
                                                          sm: "4",
                                                          cols: "12"
                                                        }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "delegation.form.fields.country.breakfastCount.name"
                                                            ),
                                                            disabled: "",
                                                            value: 0
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          md: "2",
                                                          sm: "4",
                                                          cols: "12"
                                                        }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "delegation.form.fields.country.lunchCount.name"
                                                            ),
                                                            disabled: "",
                                                            value: 0
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          md: "2",
                                                          sm: "4",
                                                          cols: "12"
                                                        }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "delegation.form.fields.country.dinnerCount.name"
                                                            ),
                                                            disabled: "",
                                                            value: 0
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          md: "3",
                                                          sm: "6",
                                                          cols: "12"
                                                        }
                                                      },
                                                      [
                                                        _c("date-picker", {
                                                          attrs: {
                                                            "date-validation":
                                                              typeof _vm
                                                                .delegationErrors
                                                                .country[index]
                                                                .accommodation[
                                                                indexAccommodation
                                                              ] !== "undefined"
                                                                ? _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ].start_date
                                                                : [],
                                                            "default-button": true,
                                                            "default-value": _vm.startDateDefaultValueAccommodation(
                                                              index,
                                                              indexAccommodation
                                                            ),
                                                            label: _vm.$t(
                                                              "delegation.form.fields.accommodation.startDate.name"
                                                            ),
                                                            model:
                                                              accommodation.start_date,
                                                            readonly:
                                                              _vm.$store.state
                                                                .Delegation
                                                                .readonly ===
                                                              true
                                                          },
                                                          on: {
                                                            "update:model": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                accommodation,
                                                                "start_date",
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          md: "3",
                                                          sm: "6",
                                                          cols: "12"
                                                        }
                                                      },
                                                      [
                                                        _c("date-picker", {
                                                          attrs: {
                                                            "date-validation":
                                                              typeof _vm
                                                                .delegationErrors
                                                                .country[index]
                                                                .accommodation[
                                                                indexAccommodation
                                                              ] !== "undefined"
                                                                ? _vm
                                                                    .delegationErrors
                                                                    .country[
                                                                    index
                                                                  ]
                                                                    .accommodation[
                                                                    indexAccommodation
                                                                  ].end_date
                                                                : [],
                                                            "default-button": true,
                                                            "default-value": _vm.endDateDefaultValueAccommodation(
                                                              index,
                                                              indexAccommodation
                                                            ),
                                                            label: _vm.$t(
                                                              "delegation.form.fields.accommodation.endDate.name"
                                                            ),
                                                            model:
                                                              accommodation.end_date,
                                                            readonly:
                                                              _vm.$store.state
                                                                .Delegation
                                                                .readonly ===
                                                              true
                                                          },
                                                          on: {
                                                            "update:model": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                accommodation,
                                                                "end_date",
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c("v-spacer"),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "align-center d-flex justify-center pa-0"
                                              },
                                              [
                                                _vm.$store.state.Delegation
                                                  .readonly !== true
                                                  ? _c(
                                                      "v-tooltip",
                                                      {
                                                        staticClass:
                                                          "hidden-sm-and-down",
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.removeAccommodation(
                                                                              country,
                                                                              accommodation
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "close"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "delegation.form.removeAccommodation"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.$store.state.Delegation.readonly !==
                                        true
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "hidden-md-and-up",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeAccommodation(
                                                      country,
                                                      accommodation
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "delegation.form.removeAccommodation"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        country.accommodation.indexOf(
                                          accommodation
                                        ) !==
                                        country.accommodation.length - 1
                                          ? _c("v-divider")
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }),
                                  _vm.$store.state.Delegation.readonly !== true
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "mt-4",
                                          on: {
                                            click: function($event) {
                                              return _vm.addAccommodation(
                                                country
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "delegation.form.addAccommodation"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        { attrs: { value: 0, flat: "" } },
                        [
                          _c(
                            "v-expansion-panel",
                            { staticClass: "grey lighten-3" },
                            [
                              _c("v-expansion-panel-header", [
                                _c("span", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.$t("global.summary")) + " "
                                    )
                                  ]),
                                  _c("span", [
                                    _c("b", { staticClass: "green--text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.calculatedSummary(country, index)
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "grey lighten-5 pb-0" },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            md: "2",
                                            sm: "4",
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "error-messages":
                                                _vm.delegationErrors.country[
                                                  index
                                                ].breakfast_count,
                                              label: _vm.$t(
                                                "delegation.form.fields.country.breakfastCount.name"
                                              ),
                                              placeholder: "0",
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true
                                            },
                                            model: {
                                              value: country.breakfast_count,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  country,
                                                  "breakfast_count",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "country.breakfast_count"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            md: "2",
                                            sm: "4",
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "error-messages":
                                                _vm.delegationErrors.country[
                                                  index
                                                ].lunch_count,
                                              label: _vm.$t(
                                                "delegation.form.fields.country.lunchCount.name"
                                              ),
                                              placeholder: "0",
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true
                                            },
                                            model: {
                                              value: country.lunch_count,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  country,
                                                  "lunch_count",
                                                  $$v
                                                )
                                              },
                                              expression: "country.lunch_count"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            md: "2",
                                            sm: "4",
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "error-messages":
                                                _vm.delegationErrors.country[
                                                  index
                                                ].dinner_count,
                                              label: _vm.$t(
                                                "delegation.form.fields.country.dinnerCount.name"
                                              ),
                                              placeholder: "0",
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true
                                            },
                                            model: {
                                              value: country.dinner_count,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  country,
                                                  "dinner_count",
                                                  $$v
                                                )
                                              },
                                              expression: "country.dinner_count"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-spacer"),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            md: "6",
                                            sm: "12",
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              readonly:
                                                _vm.$store.state.Delegation
                                                  .readonly === true,
                                              label: _vm.$t(
                                                "delegation.form.diet"
                                              ),
                                              placeholder: _vm
                                                .calculatedSummary(
                                                  country,
                                                  index
                                                )
                                                .replace(
                                                  _vm.$t(
                                                    "delegation.form.diet"
                                                  ) + ": ",
                                                  ""
                                                ),
                                              disabled: ""
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _vm.$store.state.Delegation.readonly !== true
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: { click: _vm.addCountry }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.add")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }